// VoiceSpectrum.Web.T2 · v10.0.10.10 · 2026-05-19 · VoiceSpectrum AI
//
// Empty / Skeleton / Alert — small presentational helpers used across pages.

import { ReactNode } from 'react';

export function EmptyState({
  title, description, action,
}: { title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}

export function Skeleton({
  height = 16, width = '100%', radius = 5,
}: { height?: number | string; width?: number | string; radius?: number }) {
  return <div className="skeleton" style={{ width, height, borderRadius: radius }} />;
}

export function SkeletonRow({ columns = 4 }: { columns?: number }) {
  return (
    <tr>
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i}><Skeleton height={14} /></td>
      ))}
    </tr>
  );
}

export type AlertVariant = 'success' | 'info' | 'warn' | 'error';

export function Alert({
  variant, title, children,
}: { variant: AlertVariant; title?: ReactNode; children?: ReactNode }) {
  return (
    <div className={`alert alert-${variant}`}>
      <div>
        {title && <div style={{ fontWeight: 600, marginBottom: 2 }}>{title}</div>}
        {children}
      </div>
    </div>
  );
}
